import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Filler
} from 'chart.js'
import { Line } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { lineChartOptions } from '../constants'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Filler,
  ChartDataLabels
)

const LineChart = ({ chartData, todayData }) => {
  const todayRateBlock = !!todayData &&
    <p className='currency-chart__today'>
      <span className='currency-chart__today-currency'>{todayData.currency}:</span>
      <span className='currency-chart__today-currency-value'>{todayData.value}</span>
      <span
        className={'currency-chart__today-currency-percent ' +
        (todayData.dynamic.status === 'down'
          ? 'currency-chart__today-currency-percent--down'
          : 'currency-chart__today-currency-percent--up')}
      >
        ({todayData.dynamic.value})
      </span>
    </p>

  return <>
    {todayRateBlock}

    {chartData && <Line className='currency-chart__line-chart' options={lineChartOptions} data={chartData} />}
  </>
}

export default LineChart
